<template>
  <v-tooltip :text="tooltip" location="left">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="tooltipProps"
        :icon="icon"
        :color="color"
        density="compact"
        variant="elevated"
        class="mr-2"
        @click="$emit('click')"
      />
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  tooltip: string;
  color?: string;
}>();

defineEmits(["click"]);
</script>
